import { render, staticRenderFns } from "./bulk-actions-buttons.vue?vue&type=template&id=f4b0f5ec"
import script from "./bulk-actions-buttons.vue?vue&type=script&lang=js"
export * from "./bulk-actions-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports